import _ from 'lodash'
import axios from 'axios'

export const _Biblios = {
  namespaced: true,
  state: {
    /**
     * Liste des bibliothèques
     * @type {Array}
     */
    biblios: []
  },
  getters: {
    /**
     * @return {Array} liste des titre des bibliothèques
     */
    GET_BIBLIO_TITLE (state) {
      let list = []
      _.forEach(state.biblios, biblio => {
        list.push({ text: biblio.title, value: biblio.id })
      })
      return list
    },
    /**
     * indique si le nom de la bibliothèque est déjà présente dans la liste
     * @param {Object} biblio bibliothèque à vérifier
     * @return {Biblio} retourne la bibliothèque recherchée
     */
    GET_BIBLIO_BY_ID: state => id => {
      return _.cloneDeep(state.biblios.find(biblio => biblio.id === id))
    },
    GET_BIBLIO_BY_TITLE: state => title => {
      return _.cloneDeep(state.biblios.find(biblio => biblio.title === title))
    },
    /**
     * Indique si la biblio est une sous biblio
     * @return {Integer}       ID de la biblio parente sinon null
     */
    IS_SUB_BIBLIO: state => biblio => {
      // n'est pas une sous biblio
      if (biblio.sub === '0' || biblio.sub === biblio.id) {
        return null
      }
      return biblio.sub
    },
    /**
     * Retourne toutes les phrases qui matchent avec la recherche
     * @return {Array} de toutes les phrases
     */
    GET_SENTENCES: (state, getters) => search => {
      // si la recherche fait moins de 3 caractères
      // pas de recherche
      if (!search || search.length < 3) {
        return []
      }
      // recherche de toutes les phrases
      let sentences = []
      _.each(state.biblios, biblio => {
        sentences.push(biblio.sentences)
        if (biblio.subs) {
          _.each(biblio.subs, sub => {
            sentences.push(sub.sentences)
          })
        }
      })
      sentences = _.flattenDeep(sentences)
      // recherche parmis toutes les phrases
      search = search.toString().toLowerCase()
      return _.filter(sentences, s => {
        return _.includes(s.title.toLowerCase(), search)
      })
    }
  },
  mutations: {
    INIT (state) {
      state.biblios = []
    },
    /**
     * Défini la liste de biblio gérée par le store
     * @param {Object} biblios nouvelle biblio gérée
     */
    SET_BIBLIOS (state, biblios) {
      state.biblios = biblios
    },
    /**
     * Ajoute une biblio dans la liste
     * @param {Object} biblio nouvelle biblio ajoutée
     */
    ADD_BIBLIO (state, biblio) {
      // check s'il s'agit d'une sous-biblio
      let isSub = _.isNil(biblio.subs)
      // s'il s'agit d'une biblio et non d'une sous-biblio
      if (!isSub) {
        state.biblios.push(biblio)
      } else {
        // recherche de l'indice de la biblio parente dans la liste des biblios
        let idxParent = _.findIndex(state.biblios, {'id': biblio.sub})
        // mise à jour de la bibliothèque
        state.biblios[idxParent].subs.push(biblio)
      }
    },
    /**
     * Met à jour une bibliothèque de la liste
     * @param  {Object} biblio nouvelle valeur de la biblio à mettre à jour
     */
    UPDATE_BIBLIO (state, biblio) {
      // check s'il s'agit d'une sous-biblio
      let isSub = _.isNil(biblio.subs)
      // s'il s'agit d'une biblio et non d'une sous-biblio
      if (!isSub) {
        let idx = _.findIndex(state.biblios, {'id': biblio.id})
        state.biblios.splice(idx, 1, biblio)
      } else {
        // recherche de l'indice de la biblio parente dans la liste des biblios
        let idxParent = _.findIndex(state.biblios, {'id': biblio.sub})
        // recherche de l'indice de la sous-biblio que l'on veut mettre à jour
        let idxSub = _.findIndex(state.biblios[idxParent].subs, {'id': biblio.id})
        // mise à jour de la sous-bibliothèque
        state.biblios[idxParent].subs.splice(idxSub, 1, biblio)
      }
    },
    /**
     * Supprime une bibliothèque de la liste
     * @param  {Object} biblio Bibliothèque à supprimer
     */
    REMOVE_BIBLIO (state, biblio) {
      // check s'il s'agit d'une sous-biblio
      let isSub = _.isNil(biblio.subs)
      // s'il s'agit d'une biblio et non d'une sous-biblio
      if (!isSub) {
        let idx = _.findIndex(state.biblios, {'id': biblio.id})
        state.biblios.splice(idx, 1)
      } else {
        // recherche de l'indice de la biblio parente dans la liste des biblios
        let idxParent = _.findIndex(state.biblios, {'id': biblio.sub})
        // recherche de l'indice de la sous-biblio que l'on veut mettre à jour
        let idxSub = _.findIndex(state.biblios[idxParent].subs, {'id': biblio.id})
        // mise à jour de la sous-bibliothèque
        state.biblios[idxParent].subs.splice(idxSub, 1)
      }
    }
  },

  actions: {
    /**
     * Récupère les biblios en BDD
     * formate le résultat et le stock dans le store
     */
    GET ({ commit, state, getters }, agentId) {
      return new Promise((resolve, reject) => {
        // Reset des biblios
        commit('INIT')
        // requête
        axios.get('get/sentences.php?agentId=' + agentId)
        .then(response => {
          // la réponse contient un array de array
          // le premier array : phrases
          // le second array : bibliothèques
          let list = response.data
          // Création de la bibliothèque par défaut si aucune biblio
          let biblioDefault = false
          for (var i = 0; i < list['sentences'].length; i++) {
            if (list['sentences'][i].fam_id === '0') {
              biblioDefault = true
            }
          }
          if (biblioDefault) {
            commit('ADD_BIBLIO', {
              id: '0',
              title: 'bibliothèque par défaut',
              sentences: [],
              subs: []
            })
          }
          // parcours de la liste de bibliothèques
          // afin de créer les biblios persos
          // ainsi que les sous-bibliothèques
          _.each(list['biblios'], biblio => {
            // initialisation de la liste de phrases de la bibliothèque
            biblio.sentences = []
            let biblioExists = getters.GET_BIBLIO_BY_ID(biblio.id)
            let isSub = getters.IS_SUB_BIBLIO(biblio)
            // si pas trouvé et pas une sous-biblio
            // alors on l'ajoute dans la liste des biblios du store
            if (!biblioExists && !isSub) {
              biblio.subs = []
              commit('ADD_BIBLIO', biblio)
            } else if (isSub) {
              // ajouter la sous-biblio dans la biblio parent
              let parent = getters.GET_BIBLIO_BY_ID(isSub)
              parent.subs.push(biblio)
              commit('UPDATE_BIBLIO', parent)
            }
          })

          // parcours de la liste de phrases
          _.each(list['sentences'], sentence => {
            // recherche de la biblio avec son id
            let biblioFound = _.cloneDeep(_.find(state.biblios, { 'id': sentence.fam_id }))
            // si trouvé alors on ajoute la phrase dans la biblio trouvée
            if (biblioFound) {
              // création du tableau de phrases si n'existe pas
              if (!biblioFound.sentences) { biblioFound.sentences = [] }
              // ajout de la phrase parcouru dans la bibliothèque
              biblioFound.sentences.push({
                id: sentence.id,
                title: sentence.title
              })
              commit('UPDATE_BIBLIO', biblioFound)
            } else {
              // savoir si la phrase est dans une sous-bibliothèque
              // alors on l'ajoute dedans
              _.each(state.biblios, biblio => {
                let biblioCloned = _.cloneDeep(biblio)
                _.each(biblioCloned.subs, sub => {
                  if (sentence.fam_id === sub.id) {
                    sub.sentences.push({
                      id: sentence.id,
                      title: sentence.title
                    })
                  }
                })
                commit('UPDATE_BIBLIO', biblioCloned)
              })
            }
          })
          resolve(state)
        })
        .catch(e => {
          reject(e)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/biblios.js